import { Box } from '@mui/material';
import { BackgroundConfig } from '../helpers/backgroundHelper';
import RenderMeetingViewTemplate from './meetingViewTemplates/renderMeetingViewTemplate';

type Props = {
  backgroundConfig: BackgroundConfig;
};

const OutputViewerWithoutSource = (props: Props) => {
  return (
    <Box sx={{ flex: 1, position: 'relative' }}>
      {props.backgroundConfig.type === 'image' && (
        <Box
          component={'img'}
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
          src={
            props.backgroundConfig.url instanceof Blob
              ? URL.createObjectURL(props.backgroundConfig.url)
              : props.backgroundConfig.url
          }
          alt=""
          // hidden={props.segmentationConfig.pipeline === 'webgl2'}
        />
      )}
      <RenderMeetingViewTemplate />
      {/* <MeetingTemplateOne /> */}
    </Box>
  );
};

export default OutputViewerWithoutSource;
